import React, { useState } from "react";
import PaginationButton from "../commanComponents/buttons/PaginationButton";
import BorderButton from "../commanComponents/buttons/BorderButton";
import svgData from "../constants/utilities/svgData";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { PaginationContext } from "../constants/context/PaginationProvider";
import { communication, getServerUrl } from "../constants/apis/communication";
import { useQuery, useMutation } from "react-query";
import useDebounce from "../constants/helpers/useDebounce";
import Loader from "../commanComponents/Loader";
import SelectMine from "../commanComponents/SelectMine";
import { getUserDetails } from "../constants/helpers/getUserDetails";

export default function EmployeeMaster() {
  const navigate = useNavigate();
  const { globalSearchString } = React.useContext(PaginationContext);
  const [page, setPage] = useState(1);
  const debouncedSearchTerm = useDebounce(globalSearchString, 1000, setPage);
  const [selectedMine, setSelectedMine] = useState(getUserDetails()?.mineId || "");
  const pageLimit = process.env.REACT_APP_PUBLIC_LIMIT;

  const user = getUserDetails();
  const userRoles = Array.isArray(user?.designation) ? user.designation.map(d => d.toLowerCase()) : (typeof user?.designation === "string" ? [user.designation.toLowerCase()] : []);
  const isSuperAdmin = userRoles.includes("superadmin");

  const { data: employee, isFetching } = useQuery(
    ["getEmployeeList", page, debouncedSearchTerm, selectedMine],
    () => communication?.getEmployeeList({ searchString: debouncedSearchTerm, page, mineId: selectedMine }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data?.data?.status === "JWT_INVALID") {
          toast.error(`Failed: ${data?.data?.message}`);
        } else if (data?.data?.status === "FAILED") {
          toast.error(`Failed: ${data?.data?.message}`);
        }
      },
      onError: (error) => {
        toast.error(`Failed: ${error?.message}`);
      },
    }
  );

  const { mutate: downloadFailedRecords, isLoading: downloading } = useMutation(() => communication?.failedRecordExport({ module: "employee" }), {
    onSuccess: (data) => {
      if (data?.data?.status === "SUCCESS") {
        const downloadUrl = data.data.downloadUrl;
        const fullUrl = `${getServerUrl()}/getFiles/${downloadUrl}`;

        const link = document.createElement("a");
        link.href = fullUrl;
        link.setAttribute("download", "");
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.remove();

        toast.success(data?.data?.message || "Failed records report downloaded successfully");
      } else {
        toast.error(data?.data?.message || "Failed to download report");
      }
    },
    onError: (error) => {
      console.error("Download error:", error);
      toast.error(error?.response?.data?.message || "An error occurred while downloading the report");
    },
  });

  const { mutate: downloadMissingDataReport, isLoading: downloadingMissing } = useMutation(() => communication?.employeeMissingDataReport(), {
    onSuccess: (data) => {
      console.log(data, "data");
      // return;
      if (data?.data?.status === "SUCCESS") {
        toast.success(data?.data?.message || "Missing data report downloaded successfully");

        const downloadUrl = data.data.downloadUrl;

        if (downloadUrl) {
          const fullUrl = `${getServerUrl()}/getFiles/${downloadUrl}`;

          const link = document.createElement("a");
          link.href = fullUrl;
          link.setAttribute("download", "");
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } else {
        toast.error(data?.data?.message || "Failed to download report");
      }
    },
    onError: (error) => {
      console.error("Download error:", error);
      toast.error(error?.response?.data?.message || "An error occurred while downloading the report");
    },
  });

  return (
    <>
      {(isFetching || downloading || downloadingMissing) && <Loader />}
      <div className="pageWrapper">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
          <div className="settingsBtnContainer d-flex gap-3 flex-wrap align-items-center">
            <BorderButton text="Employee Master" icon={svgData?.employeeMasterIcon} onClick={() => navigate("/panel/settings/employee-master")} isActive={true} />
            <BorderButton text="Equipment Master" icon={svgData?.hammerIcon} onClick={() => navigate("/panel/settings/equipment-master")} isActive={false} />

            <button className="premiumReportBtn" style={{ backgroundColor: "#EB7805" }} onClick={() => downloadMissingDataReport()} disabled={downloadingMissing}>
              Missing Data Report
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </button>

            <button className="premiumReportBtn" style={{ backgroundColor: "#E80B00" }} onClick={() => downloadFailedRecords()} disabled={downloading}>
              Failed Records Reports
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </button>
          </div>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <SelectMine selectedMine={selectedMine} onChange={(e) => setSelectedMine(e.target.value)} />
            <PaginationButton setPage={setPage} page={page} totalPages={employee?.data?.employee?.totalPages} />
          </div>
        </div>

        <div className="mt-2">
          <div className="tableWrapper comman-box-shadow" style={{ position: "relative", height: "70vh" }}>
            <table style={{ minWidth: "2050px" }}>
              <thead>
                <tr>
                  <th className="text-center col_80px">Sr. No.</th>
                  {isSuperAdmin && <th className="col_100px">Mine Id</th>}
                  <th className="col_100px">Employee No.</th>
                  <th className="col_250px">Employee Name</th>
                  <th className="col_150px">Employee Group</th>
                  <th className="col_190px">Employee Subgroup</th>
                  <th className="col_200px">Employee Subgroup Text</th>
                  <th className="col_350px">Position Name</th>
                  <th className="col_150px">Department</th>
                  {/* <th className="col_150px">Personnel Subarea Text</th> */}
                  <th className="col_90px">Gender</th>
                  {/* <th className="col_150px">Name of Department</th> */}
                  <th className="col_150px">Mobile Number</th>
                  <th className="col_90px">Shift</th>
                  <th className="col_150px">Designation</th>
                </tr>
              </thead>
              <tbody>
                {employee?.data?.employee?.users?.map((item, index) => (
                  <tr key={item?._id} className={index % 2 === 0 ? "skyBlueTrBg" : ""}>
                    <td className="text-center">{(page - 1) * pageLimit + (index + 1)}</td>
                    {isSuperAdmin && <td className="">{item?.mineCode || "--"}</td>}
                    <td className="">{item?.employeeNumber || "--"}</td>
                    <td className="">{item?.employeeName || "--"}</td>
                    <td className="">{item?.employeeGroup || "--"}</td>
                    <td className="">{item?.employeeSubgroup || "--"}</td>
                    <td className="">{item?.employeeSubgroupText || "--"}</td>

                    <td className="">{item?.positionName || "--"}</td>
                    <td className="">{item?.department || "--"}</td>
                    {/* <td className="">{item?.personnelSubareaText || "--"}</td> */}
                    <td className="">{item?.gender || "--"}</td>
                    {/* <td className="">{item?.nameOfDepartment || "--"}</td> */}
                    <td className="">{item?.phoneNumber || "--"}</td>
                    <td className="">{item?.shift || "--"}</td>
                    <td className="">{item?.mineDesignation || "--"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {(!employee?.data?.employee?.users || employee?.data?.employee?.users?.length === 0) && <h6 className="noDataAvailableWrapper">No Data Available</h6>}
          </div>
        </div>
      </div>
    </>
  );
}
